export const QA_CATEGORIES = [
  "SDET / Test Automation",
  "Manual & Functional QA",
  "QA Leadership & Management",
  "Performance & Load Testing",
  "API & Integration Testing",
  "Security & Pen Testing",
] as const;

export type QaCategory = (typeof QA_CATEGORIES)[number];

export const EXPERIENCE_LEVELS = [
  "Entry (0-2 Yrs)",
  "Mid-Level (2-5 Yrs)",
  "Senior (5-8 Yrs)",
  "Lead / Architect (8+ Yrs)",
  "Manager / Director",
  "Not Specified",
] as const;

export type ExperienceLevel = (typeof EXPERIENCE_LEVELS)[number];

export const WORKPLACE_TYPES = ["Remote", "Hybrid", "On-Site"] as const;

export type WorkplaceType = (typeof WORKPLACE_TYPES)[number];

export const JOB_SORT_OPTIONS = ["newest", "enterprise", "exp_asc"] as const;

export type JobSortOption = (typeof JOB_SORT_OPTIONS)[number];

/** Safe minimal DTO passed to listing cards and client components. */
export interface QaJobSummary {
  fingerprint: string;
  slug: string;
  companyName: string;
  companyVerified: boolean;
  headcountEst: number | null;
  title: string;
  qaCategory: string;
  experienceLevel: string;
  minYears: number | null;
  maxYears: number | null;
  country: string;
  city: string;
  workplaceType: string;
  atsType: string;
  postedAt: string | null;
  applyUrl: string | null;
  descriptionSnippet: string;
  skills: string[];
}

/** Rich sanitized DTO for the individual job details page. */
export interface QaJobDetail extends QaJobSummary {
  companySlug: string | null;
  verificationSource: string | null;
  employmentType: string;
  description: string;
  validThrough: string | null;
  applicants: string | null;
  status: string;
}

export interface QaJobFilters {
  q: string;
  country: string;
  category: string;
  level: string;
  workplace: string;
  maxExp: number | null;
  ats: string;
  sort: JobSortOption;
  page: number;
}

export interface FacetItem {
  value: string;
  count: number;
}

export interface QaJobsFacets {
  totalActiveJobs: number;
  verifiedEmployersCount: number;
  lastSyncAt: string | null;
  categories: FacetItem[];
  experienceLevels: FacetItem[];
  workplaceTypes: FacetItem[];
  countries: FacetItem[];
  atsTypes: FacetItem[];
}

export interface QaJobsPageResult {
  jobs: QaJobSummary[];
  totalMatching: number;
  page: number;
  pageSize: number;
  totalPages: number;
  filters: QaJobFilters;
  facets: QaJobsFacets;
}

export interface TargetQaPrepLink {
  title: string;
  subtitle: string;
  href: string;
  badge: string;
}

export type DescriptionBlock =
  | { kind: "heading"; text: string }
  | { kind: "paragraph"; text: string }
  | { kind: "bullets"; items: string[] };
